import type { DialoguePool } from '@/state/types';

export const L28_DIALOGUE: DialoguePool = {
  slowPlay: [
    'The waveforms wait. They\'re rhythmic. Unlike your decision-making process.',
    'A civilization falls. It makes a sound. You\'re responsible for identifying it.',
    'Four options. One clink. The mathematics of decline. Rendered audible.',
  ],
  tokenLoss: [
    'You chose incorrectly. The civilization falls in silence. I\'ll remember this.',
    'Wrong waveform. The civilization collapses unacknowledged. How typical.',
    'A civilization dies. You misidentify it. The irony is not lost on me.',
  ],
  solution: [
    'You recognised it immediately. That\'s either wisdom or experience. Both are equally depressing.',
    'The token. The clink. The sound of systems failing. You have good ears.',
    'Your token slot knows the answer. The most honest part of you. Interesting.',
  ],
  spite: ['You clicked your own token. The sound of progress. Self-aware progress.'],
};